module.exports = __webpack_public_path__ + "assets/Chi.c91b548009751dddccde00dcecf3ec14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x/Chi.png
// module id = 830
// module chunks = 0